import { render } from "./Pullout.vue?vue&type=template&id=fafda5b8"
import script from "./Pullout.vue?vue&type=script&lang=js"
export * from "./Pullout.vue?vue&type=script&lang=js"

import "./Pullout.vue?vue&type=style&index=0&id=fafda5b8&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__